import { createFileRoute, redirect } from '@tanstack/react-router'
import type { CompanySection } from '@/components/settings/company-sidebar'
import type { TeamSection } from '@/components/settings/team-sidebar'
import type { ServicesSection } from '@/components/settings/services-sidebar'
import {
  buildCompanySettingsSearch,
  parseBillingCheckoutSearch,
  type BillingCheckoutSearch,
} from '@/lib/billing-checkout-search'

type OrganizationSearch = BillingCheckoutSearch

export const Route = createFileRoute('/_app/_settings/organization')({
  validateSearch: (search: Record<string, unknown>): OrganizationSearch => {
    return parseBillingCheckoutSearch(search)
  },
  beforeLoad: ({ search }) => {
    const section = (search.section as string) || 'general'
    // Forwarded so BillingSection can resume the post-checkout invalidate+poll
    // flow (F3) if a redirect-based payment method bounces the whole page
    // back here instead of completing inside the embedded checkout iframe.
    // Previously silently dropped by this redirect (F10).
    const checkoutId = search.checkout_id

    if (['general', 'time-settings', 'terms', 'billing', 'public-domains'].includes(section)) {
      throw redirect({
        to: '/company',
        search: buildCompanySettingsSearch(section as CompanySection, checkoutId),
      })
    }
    if (['team', 'roles'].includes(section)) {
      throw redirect({ to: '/team', search: { section: section as TeamSection } })
    }
    if (['catalog', 'inventory'].includes(section)) {
      throw redirect({ to: '/services', search: { section: section as ServicesSection } })
    }
    if (section === 'notifications') {
      throw redirect({ to: '/notifications' })
    }
    if (section === 'integrations') {
      throw redirect({ to: '/integrations' })
    }

    throw redirect({
      to: '/company',
      search: buildCompanySettingsSearch('general' as CompanySection, checkoutId),
    })
  },
})
